<div
  [class.min-h-screen]="!isContentStart"
  [class.mt-4]="isContentStart"
  class="flex justify-center items-center"
>
  <div
    class="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-[#FF5858]"
  ></div>
</div>
